import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination';

const Assign_plans = () => {
    const { plan_id } = useParams();
    console.log("plan_id == " , plan_id)
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [customers, setCustomers] = useState([]);
  const [assignedCustomers, setAssignedCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
        homeSection.classList.toggle('sidebar-closed');
    }
};

  useEffect(() => {
    fetchCustomers();
    fetchAssigned();
  }, []);

  const fetchCustomers = async () => {
    const res = await axios.post(`${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/fetch_all_customers`,{},{headers: exportValue.headers});
    if (res.data.success) setCustomers(res.data.customers);
  };

  const fetchAssigned = async () => {
    let sendData = {plan_id:plan_id}
    console.log("senddata",sendData)
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api+'/assigned_plan_customers'
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
        if (res.data.success) setAssignedCustomers(res.data.customers);
    }).catch((e) => {


    });
   
  };

  const handleAssign = async () => {
    if (!selectedCustomer) {
      Swal.fire("Warning", "Please select a customer", "warning");
      return;
    }
  
    let sendData = {
      plan_id: plan_id,
      customer_id: selectedCustomer,
    };
  
    try {
      const res = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/assign_plans`,
        sendData,
        { headers: exportValue.headers }
      );
  
      if (res.data.success) {
        fetchAssigned();
        fetchCustomers();
        Swal.fire("Success", "Plan assigned successfully", "success");
      } else {
        Swal.fire("Error", "Assign failed", "error");
      }
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };
  
  const handleUnassign = async (customer_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Unassign this plan from customer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, unassign it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let sendData = {
          plan_id: plan_id,
          customer_id: customer_id,
        };
  
        try {
          const res = await axios.post(
            `${exportValue.host}/${exportValue.version}/${exportValue.api}/unassign_plan`,
            sendData,
            { headers: exportValue.headers }
          );
  
          if (res.data.success) {
            fetchAssigned();
            fetchCustomers();
            Swal.fire("Success", "Plan unassigned successfully", "success");
          } else {
            Swal.fire("Error", "Unassign failed", "error");
          }
        } catch (err) {
          Swal.fire("Error", err.message, "error");
        }
      }
    });
  };
  return (
    <div>
       
          <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <section class="home-section">
        <Sub_header/>
        <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3>Assign Plan: {plan_id}</h3>
        <div>
          <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>Back</button>
        </div>
      </div>

      <div className="mb-5">
        <select className="form-select" value={selectedCustomer} onChange={e => setSelectedCustomer(e.target.value)}>
          <option value="">Select Customer</option>
          {customers.map(c => (
            <option key={c.customer_id} value={c.customer_id}>
              {c.full_name || c.customer_id} {c.email ? `(${c.email})` : ""}
            </option>
          ))}
        </select>
        <div className="mt-2">
          <button className="btn btn-primary" onClick={handleAssign}>Assign</button>
        </div>
      </div>

      <h5>Assigned Customers</h5>
      <table className="table table-bordered">
        <thead><tr><th>Customer ID</th><th>Name</th><th>Email</th><th>Action</th></tr></thead>
        <tbody>
          {assignedCustomers.map(c => (
            <tr key={c.customer_id}>
              <td>{c.customer_id}</td>
              <td>{c.full_name}</td>
              <td>{c.email}</td>
              <td><button className="btn btn-danger btn-sm" onClick={() => handleUnassign(c.customer_id)}>Unassign</button></td>
            </tr>
          ))}
        </tbody>
      </table>
        </section>
    </div>
  )
}

export default Assign_plans
